import {
  RadioGroup,
  RadioTile,
  media,
  useMediaQuery,
} from '@utilitywarehouse/hearth-react';
import { useFormikContext } from 'formik';
import { FC } from 'react';

import { EnergyFuelType } from '@generated/gql/graphql';
import { useFieldProps } from '@hooks/useFieldProps';
import { EnergyDetailsFormValues } from '@src/types/energy';

import './styles.scss';

interface EnergyRadioFieldProps {
  disabled: boolean;
}

const FIELD_NAME = 'fuelType';

const EnergyRadioField: FC<EnergyRadioFieldProps> = ({ disabled }) => {
  const isMobile = useMediaQuery(media.below('tablet'));
  const {
    values,
    errors,
    handleChange,
    handleBlur,
    touched,
    submitCount,
    setFieldValue,
  } = useFormikContext<EnergyDetailsFormValues>();

  const getFieldProps = useFieldProps<EnergyDetailsFormValues>({
    errors,
    values,
    handleBlur,
    handleChange,
    touched,
    submitCount,
  });

  return (
    <div className="energyDetailsForm__energyRadioField">
      <RadioGroup
        {...getFieldProps(FIELD_NAME)}
        direction={isMobile ? 'column' : 'row'}
        label="What energy do you need?"
        disabled={disabled}
        onValueChange={(val: string) => setFieldValue(FIELD_NAME, val)}
        validationPlacement="bottom"
        contentWidth={isMobile ? '100%' : '100%'}
      >
        <RadioTile
          value={EnergyFuelType.DualFuel}
          label="Electricity and gas"
          data-testid="energy-service-dual"
          id="energy-service-dual"
        />
        <RadioTile
          value={EnergyFuelType.ElectricityOnly}
          label="Electricity only"
          data-testid="energy-service-electricity"
          id="energy-service-electricity"
        />
        <RadioTile
          value={EnergyFuelType.GasOnly}
          label="Gas only"
          data-testid="energy-service-gas"
          id="energy-service-gas"
        />
      </RadioGroup>
    </div>
  );
};

export { EnergyRadioField };
